














































import { Component, Prop, Vue } from 'vue-property-decorator';
import { SVGPathData, encodeSVGPath } from 'svg-pathdata';

import * as def from '@/definitions'
import { Const } from '@/const'

import { Rectangle } from '@/utilityModels/rectangle';
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { TextInfo } from '@/utilityModels/textInfo';
import { UnitHelper } from '@/helper/unitHelper';
import { MathHelper } from '@/helper/mathHelper';
import { UuidHelper } from '@/helper/uuidHelper';
import { FontManager } from '@/model/fontManager/fontManager';
import { StringHelper } from '@/helper/stringHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { CircleTextLayer } from '@/model/document2/page/surface/design/layer/circleTextLayer';

@Component({
    components: {
    },
})
export default class CircleTextLayerDrawer extends Vue
{
    // プレースホルダー
    static readonly PLACEHOLDER_OPACITY = 0.5;
    // 文字の高さに対する下線の割合
    static readonly UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT = 1 / 18.0;

    // 最小フォントサイズ(pt)
    static readonly MIN_FONT_SIZE = 1;
    static readonly MAX_FONT_SIZE = 720;

    @Prop() private layer!: CircleTextLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;
    // 直接印刷ではクライアントで処理するのでサーバー用のフォントになると困る
    @Prop({default : false}) private isRenderingOnClient!: boolean;
    // エディット対象かどうか？
    // 編集面選択に表示されている場合は、キャレットとプレースホルダを表示しないため
    @Prop({ default: false }) private isInEditor! : boolean;

    // マウント済みフラグ
    private ismounted = false;
    mounted() { this.ismounted = true; }

    // 不透明度(0 ~ 1.0)
    private get opacity()
    {
        var value = this.layer.opacity / 100;
        if(this.isPlaceholderVisible) { value *= CircleTextLayerDrawer.PLACEHOLDER_OPACITY; }
        if(value < 0) { value = 0; }
        if(value > 1) { value = 1; }
        return value;
    }

    // プレースホルダー
    private get isPlaceholderVisible()
    {
        // マウント前は表示しない
        if(!this.ismounted) { return false; }
        // 編集中は表示しない
        if(this.layer.inEdit) { return false; }
        // レンダリング中は表示しない
        if(this.isRendering) { return false; }
        // エディット対象でなければ表示しない
        if(!this.isInEditor) { return false; }
        // 印刷は表示しない
        var path = this.$router.currentRoute.path;
        if(path == "/PrintSetting") { return false; }
        // レイアウトは表示しない
        if(path == "/LayoutEditor") { return false; }
        // 文字列が空なら表示
        return this.layer.text == "";
    }

    // 文字情報配列
    private get characterInfoArray() : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        rotate : number,                // 傾き(degrees)
        uuid : string,                  // UUID
        boundsBefore : Rectangle,       // 文字ポジション判定領域(前)
        boundsAfter : Rectangle         // 文字ポジション判定領域(後)
    }>
    {
        // テキスト方向により返す情報配列を振り分ける
        return this.layer.textOrientation == 1 ? this.characterInfoArrayVertical : this.characterInfoArrayHorizontal;
    }

    // 横書き
    private get characterInfoArrayHorizontal() : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        rotate : number,                // 傾き(degrees)
        uuid : string,                  // UUID
        boundsBefore : Rectangle,       // 文字ポジション判定領域(前)
        boundsAfter : Rectangle         // 文字ポジション判定領域(後)
    }>
    {
        var array = new Array();

        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return new Array(); }

        array = this.getCharacterInfoArrayHorizontal();

        return array;
    }

    // 横書き配置
    // isAutoNewLine : 自動改行する falseの場合はレイヤーの文字列での改行以外で改行しない
    // isSameFontSize : すべて同じフォントサイズを使用する
    // fontSize : 同じフォントサイズを使用する場合のフォントサイズ(pt)
    private getCharacterInfoArrayHorizontal() : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        rotate : number,                // 傾き(degrees)
        uuid : string,                  // UUID
        boundsBefore : Rectangle,       // 文字ポジション判定領域(前)
        boundsAfter : Rectangle         // 文字ポジション判定領域(後)
    }>
    {
        var array = new Array();

        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return array; }

        // フォントマネージャー
        var fontManager : FontManager = this.$store.getters.fontManager;

        // 描画範囲となる円周の中心
        var centerX = this.layer.x * this.scale + this.offsetX + this.layer.width * this.scale / 2;
        var centerY = this.layer.y * this.scale + this.offsetY + this.layer.height * this.scale / 2;
        // 中心からの距離
        var maxr = Math.min(this.layer.width, this.layer.height) * this.scale / 2;
        var r = maxr;
        // 現在のフォントサイズへの縮小率
        var rate = 1;
        // 行ごと描画していく
        if(this.layer.direction == 1)
        {
            // 内向き
            // 最終行から置いていく
            for(var lineIndex = this.layer.getLineCount(this.isPlaceholderVisible) - 1; lineIndex >= 0; --lineIndex)
            {
                var characterCount = this.layer.getCharacterCount(lineIndex, this.isPlaceholderVisible);
                // 縮小率更新
                rate = r / maxr;
                // この行の全文字の最大高さ、トータル幅を測る
                var maxHeight = 0;
                var totalWidth = 0;
                if(characterCount == 0)
                {
                    // 空白行
                    var info = this.layer.getCharacterInfo(lineIndex, 0, this.isPlaceholderVisible);
                    if(info != null)
                    {
                        var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                        var size = this.calcTextSize("8", scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, false);
                        if(size.height > maxHeight) { maxHeight = size.height; }
                    }
                }
                else
                {
                    for(var characterIndex = 0; characterIndex < characterCount; ++characterIndex)
                    {
                        var info = this.layer.getCharacterInfo(lineIndex, characterIndex, this.isPlaceholderVisible);
                        if(info != null)
                        {
                            var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                            var isHankaku = StringHelper.isHankaku(info.character);
                            var size = this.calcTextSize(info.character, scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, false);
                            totalWidth += size.width * info.textInfo.letterWidth / 100;
                            if(size.height > maxHeight) { maxHeight = size.height; }
                            if(characterIndex < characterCount - 1)
                            {
                                totalWidth += UnitHelper.convert(info.textInfo.letterSpacing, "pt", "mm") * this.scale * rate;
                            }
                            // 最初と最後の文字は半分まで
                            if(characterIndex == 0) { totalWidth -= size.width * info.textInfo.letterWidth / 100 / 2; }
                            if(characterIndex == characterCount - 1) { totalWidth -= size.width * info.textInfo.letterWidth / 100 / 2; }
                        }
                    }
                }

                // 最大高さが1未満になったら抜ける
                if(maxHeight < 1) { break; }

                // 距離
                r -= maxHeight;

                // 半径が0になったら抜ける
                if(r <= 0) { break; }

                // 円周
                var c = 2 * r * Math.PI;
                // 円周に対する文字長さの割合
                var textRate = Math.min(totalWidth / c, 1.0);
                // 最初の文字を描く基準位置(文字の中央下)の角度(真下を0とする)
                var degrees = 0;
                if(this.layer.horizontalAlignment == 0)
                {
                    // 左揃え
                    degrees = 90;
                }
                else if(this.layer.horizontalAlignment == 1)
                {
                    // 中央揃え
                    degrees = 180 * textRate;
                }
                else if(this.layer.horizontalAlignment == 2)
                {
                    // 右揃え
                    degrees = -90 + 360 * textRate;
                }

                if(characterCount == 0)
                {
                    // 空白行
                    var info = this.layer.getCharacterInfo(lineIndex, 0, this.isPlaceholderVisible);
                    if(info != null)
                    {
                        var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                        var size = this.calcTextSize("8", scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, false);
                        var rad = degrees * Math.PI / 180;
                        var x = centerX - (r + maxHeight) * Math.sin(rad) - size.width * info.textInfo.letterWidth / 100 * Math.cos(rad) / 2;
                        var y = centerY + (r + maxHeight) * Math.cos(rad) - size.width * info.textInfo.letterWidth / 100 * Math.sin(rad) / 2;

                        array.push({
                            character : info.character,
                            lineIndex : lineIndex,
                            characterIndex : 0,
                            textInfo : info.textInfo,
                            x : x,
                            y : y,
                            width : size.width,
                            height : size.height,
                            fontSize : scaledFontSize,
                            letterWidth : info.textInfo.letterWidth,
                            rotate : degrees,
                            uuid : UuidHelper.getUuid(),
                            boundsBefore : new Rectangle(),
                            boundsAfter : new Rectangle()
                        });
                    }
                }
                else
                {
                    for(var characterIndex = 0; characterIndex < characterCount; ++characterIndex)
                    {
                        var info = this.layer.getCharacterInfo(lineIndex, characterIndex, this.isPlaceholderVisible);
                        if(info != null)
                        {
                            var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                            var isHankaku = StringHelper.isHankaku(info.character);
                            var size = this.calcTextSize(info.character, scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, false);
                            // 文字送り
                            if(characterIndex > 0)degrees -= 360 * size.width * info.textInfo.letterWidth / 100 / c / 2;
                            var rad = degrees * Math.PI / 180;
                            var x = centerX - (r + maxHeight) * Math.sin(rad) - size.width * info.textInfo.letterWidth / 100 * Math.cos(rad) / 2;
                            var y = centerY + (r + maxHeight) * Math.cos(rad) - size.width * info.textInfo.letterWidth / 100 * Math.sin(rad) / 2;

                            array.push({
                                character : info.character,
                                lineIndex : lineIndex,
                                characterIndex : characterIndex,
                                textInfo : info.textInfo,
                                x : x,
                                y : y,
                                width : size.width,
                                height : size.height,
                                fontSize : scaledFontSize,
                                letterWidth : info.textInfo.letterWidth,
                                rotate : degrees,
                                uuid : UuidHelper.getUuid(),
                                boundsBefore : new Rectangle(),
                                boundsAfter : new Rectangle()
                            });
                            // 文字送り
                            degrees -= 360 * size.width * info.textInfo.letterWidth / 100 / c / 2;
                            // 文字間を空ける
                            var dx = UnitHelper.convert(info.textInfo.letterSpacing, "pt", "mm") * rate * this.scale;
                            degrees -= 360 * dx / c;
                        }
                    }
                }
                // 行間を空ける
                r -= maxHeight * (this.layer.lineSpacing - 100) / 100;

                // 半径が0になったら抜ける
                if(r <= 0) { break; }
            }
        }
        else
        {
            // 外向き
            for(var lineIndex = 0; lineIndex < this.layer.getLineCount(this.isPlaceholderVisible); ++lineIndex)
            {
                var characterCount = this.layer.getCharacterCount(lineIndex, this.isPlaceholderVisible);
                // 縮小率更新
                rate = r / maxr;
                // この行の全文字の最大高さ、トータル幅を測る
                var maxHeight = 0;
                var totalWidth = 0;
                if(characterCount == 0)
                {
                    // 空白行
                    var info = this.layer.getCharacterInfo(lineIndex, 0, this.isPlaceholderVisible);
                    if(info != null)
                    {
                        var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                        var size = this.calcTextSize("8", scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, false);
                        if(size.height > maxHeight) { maxHeight = size.height; }
                    }
                }
                else
                {
                    for(var characterIndex = 0; characterIndex < characterCount; ++characterIndex)
                    {
                        var info = this.layer.getCharacterInfo(lineIndex, characterIndex, this.isPlaceholderVisible);
                        if(info != null)
                        {
                            var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                            var isHankaku = StringHelper.isHankaku(info.character);
                            var size = this.calcTextSize(info.character, scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, false);
                            totalWidth += size.width * info.textInfo.letterWidth / 100;
                            if(size.height > maxHeight) { maxHeight = size.height; }
                            if(characterIndex < characterCount - 1)
                            {
                                totalWidth += UnitHelper.convert(info.textInfo.letterSpacing, "pt", "mm") * this.scale * rate;
                            }
                            // 最初と最後の文字は半分まで
                            if(characterIndex == 0) { totalWidth -= size.width * info.textInfo.letterWidth / 100 / 2; }
                            if(characterIndex == characterCount - 1) { totalWidth -= size.width * info.textInfo.letterWidth / 100 / 2; }
                        }
                    }
                }

                // 最大高さが1未満になったら抜ける
                if(maxHeight < 1) { break; }

                // 距離
                r -= maxHeight;

                // 半径が0になったら抜ける
                if(r <= 0) { break; }

                // 円周
                var c = 2 * r * Math.PI;
                // 円周に対する文字長さの割合
                var textRate = Math.min(totalWidth / c, 1.0);
                // 最初の文字を描く基準位置(文字の中央下)の角度(真上を0とする)
                var degrees = 0;
                if(this.layer.horizontalAlignment == 0)
                {
                    // 左揃え
                    degrees = -90;
                }
                else if(this.layer.horizontalAlignment == 1)
                {
                    // 中央揃え
                    degrees = -180 * textRate;
                }
                else if(this.layer.horizontalAlignment == 2)
                {
                    // 右揃え
                    degrees = 90 - 360 * textRate;
                }

                if(characterCount == 0)
                {
                    // 空白行
                    var info = this.layer.getCharacterInfo(lineIndex, 0, this.isPlaceholderVisible);
                    if(info != null)
                    {
                        var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                        var size = this.calcTextSize("8", scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, false);
                        var rad = degrees * Math.PI / 180;
                        var x = centerX + r * Math.sin(rad) - size.width * info.textInfo.letterWidth / 100 * Math.cos(rad) / 2;
                        var y = centerY - r * Math.cos(rad) - size.width * info.textInfo.letterWidth / 100 * Math.sin(rad) / 2;

                        array.push({
                            character : info.character,
                            lineIndex : lineIndex,
                            characterIndex : 0,
                            textInfo : info.textInfo,
                            x : x,
                            y : y,
                            width : size.width,
                            height : size.height,
                            fontSize : scaledFontSize,
                            letterWidth : info.textInfo.letterWidth,
                            rotate : degrees,
                            uuid : UuidHelper.getUuid(),
                            boundsBefore : new Rectangle(),
                            boundsAfter : new Rectangle()
                        });
                    }
                }
                else
                {
                    for(var characterIndex = 0; characterIndex < characterCount; ++characterIndex)
                    {
                        var info = this.layer.getCharacterInfo(lineIndex, characterIndex, this.isPlaceholderVisible);
                        if(info != null)
                        {
                            var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                            var isHankaku = StringHelper.isHankaku(info.character);
                            var size = this.calcTextSize(info.character, scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, false);
                            // 文字送り
                            if(characterIndex > 0)degrees += 360 * size.width * info.textInfo.letterWidth / 100 / c / 2;
                            var rad = degrees * Math.PI / 180;
                            var x = centerX + r * Math.sin(rad) - size.width * info.textInfo.letterWidth / 100 * Math.cos(rad) / 2;
                            var y = centerY - r * Math.cos(rad) - size.width * info.textInfo.letterWidth / 100 * Math.sin(rad) / 2;
                            array.push({
                                character : info.character,
                                lineIndex : lineIndex,
                                characterIndex : characterIndex,
                                textInfo : info.textInfo,
                                x : x,
                                y : y,
                                width : size.width,
                                height : size.height,
                                fontSize : scaledFontSize,
                                letterWidth : info.textInfo.letterWidth,
                                rotate : degrees,
                                uuid : UuidHelper.getUuid(),
                                boundsBefore : new Rectangle(),
                                boundsAfter : new Rectangle()
                            });
                            // 文字送り
                            degrees += 360 * size.width * info.textInfo.letterWidth / 100 / c / 2;
                            // 文字間を空ける
                            var dx = UnitHelper.convert(info.textInfo.letterSpacing, "pt", "mm") * rate * this.scale;
                            degrees += 360 * dx / c;
                        }
                    }
                }
                // 行間を空ける
                r -= maxHeight * (this.layer.lineSpacing - 100) / 100;

                // 半径が0になったら抜ける
                if(r <= 0) { break; }
            }
        }

        // 判定領域設定
        for(var i = 0; i < array.length; ++i)
        {
            var bounds = new Rectangle(array[i].x, array[i].y, array[i].width, array[i].height);
            array[i].boundsBefore = new Rectangle(bounds.x, bounds.y - bounds.height, bounds.width / 2, bounds.height);
            array[i].boundsAfter = new Rectangle(bounds.x + bounds.width / 2, bounds.y - bounds.height, bounds.width / 2, bounds.height);
        }

        return array;
    }

    // 縦書き
    private get characterInfoArrayVertical() : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        rotate : number,                // 傾き(degrees)
        uuid : string,                  // UUID
        boundsBefore : Rectangle,       // 文字ポジション判定領域(前)
        boundsAfter : Rectangle         // 文字ポジション判定領域(後)
    }>
    {
        var array = new Array();

        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return array; }

        array = this.getCharacterInfoArrayVertical();

        return array;
    }

    // 縦書き配置
    // isAutoNewLine : 自動改行する falseの場合はレイヤーの文字列での改行以外で改行しない
    // isSameFontSize : すべて同じフォントサイズを使用する
    // fontSize : 同じフォントサイズを使用する場合のフォントサイズ(pt)
    private getCharacterInfoArrayVertical(isAutoNewLine = true, isSameFontSize = false, fontSize = 1) : Array<{
        character : string,             // 文字
        lineIndex : number,             // 行index
        characterIndex : number,        // 文字index
        textInfo : TextInfo,            // 文法情報
        x : number,                     // x座標(view)
        y : number,                     // y座標(view)
        width : number,                 // 幅(view)
        height : number,                // 高さ(view)
        fontSize : number,              // フォントサイズ(view)
        letterWidth : number,           // 文字幅(%)
        rotate : number,                // 傾き(degrees)
        uuid : string,                  // UUID
        boundsBefore : Rectangle,       // 文字ポジション判定領域(前)
        boundsAfter : Rectangle         // 文字ポジション判定領域(後)
    }>
    {
        var array = new Array();

        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return array; }

        // フォントマネージャー
        var fontManager : FontManager = this.$store.getters.fontManager;

        // 描画範囲となる円周の中心
        var centerX = this.layer.x * this.scale + this.offsetX + this.layer.width * this.scale / 2;
        var centerY = this.layer.y * this.scale + this.offsetY + this.layer.height * this.scale / 2;
        // 中心からの距離
        var maxr = Math.min(this.layer.width, this.layer.height) * this.scale / 2;

        // 行ごと描画していく
        if(this.layer.direction == 1)
        {
            // 内向き
            // 最初の行を描く基準位置の角度(右を0とする)
            var degrees = 0;
            // スタート半径
            for(var lineIndex = 0; lineIndex < this.layer.getLineCount(this.isPlaceholderVisible); ++lineIndex)
            {
                // 最大文字幅
                var maxWidth = this.getCharacterInfoArrayVerticalInLine(array, degrees, lineIndex, maxr, maxr, centerX, centerY, true);

                // 揃え調整
                if(this.layer.horizontalAlignment == 1)
                {
                    // 中央揃え
                    // 上揃え・下揃えの中間であることを念頭に
                    // 一番下の文字の高さ
                    var lastInfo = array[array.length - 1];
                    var lastCharacterHeight = lastInfo.height;
                    // この高さ -> 最小フォントサイズ * 4 で同じ文字を描いた時の高さ の割合
                    var minScaledFontSize = UnitHelper.convert(CircleTextLayerDrawer.MIN_FONT_SIZE * 4, "pt", "mm") * this.scale;
                    var isHankaku = StringHelper.isHankaku(lastInfo.character);
                    var minTextSize = this.calcTextSize(lastInfo.character, minScaledFontSize, lastInfo.textInfo.fontId, lastInfo.textInfo.bold, lastInfo.textInfo.italic, true);
                    var toMinScale = minTextSize.height / lastCharacterHeight;
                    // まず同じ行番号を削除
                    for(var i = array.length - 1; i >= 0; --i)
                    {
                        if(lineIndex == array[i].lineIndex) { array.splice(i, 1); }
                    }
                    var startr = maxr * (1 + toMinScale) / 2;
                    this.getCharacterInfoArrayVerticalInLine(array, degrees, lineIndex, startr, maxr, centerX, centerY, true);
                }
                else if(this.layer.horizontalAlignment == 0)
                {
                    // 上揃え
                    // 一番下の文字の高さ
                    var lastInfo = array[array.length - 1];
                    var lastCharacterHeight = lastInfo.height;
                    // この高さ -> 最小フォントサイズ * 4 で同じ文字を描いた時の高さ の割合
                    var minScaledFontSize = UnitHelper.convert(CircleTextLayerDrawer.MIN_FONT_SIZE * 4, "pt", "mm") * this.scale;
                    var isHankaku = StringHelper.isHankaku(lastInfo.character);
                    var minTextSize = this.calcTextSize(lastInfo.character, minScaledFontSize, lastInfo.textInfo.fontId, lastInfo.textInfo.bold, lastInfo.textInfo.italic, true);
                    var toMinScale = minTextSize.height / lastCharacterHeight;
                    // 初期半径をtoMinScale倍にして、この行を再設定する
                    // まず同じ行番号を削除
                    for(var i = array.length - 1; i >= 0; --i)
                    {
                        if(lineIndex == array[i].lineIndex) { array.splice(i, 1); }
                    }
                    this.getCharacterInfoArrayVerticalInLine(array, degrees, lineIndex, maxr * toMinScale, maxr, centerX, centerY, true);
                }

                // 行を送る
                // 最大文字幅が円周に占める割合で算出する
                degrees -= 360 * (maxWidth * this.layer.lineSpacing / 100) / ( maxr * 2 * Math.PI );
            }
        }
        else
        {
            // 外向き
            // 最初の行を描く基準位置の角度(右を0とする)
            var degrees = 0;

            for(var lineIndex = 0; lineIndex < this.layer.getLineCount(this.isPlaceholderVisible); ++lineIndex)
            {
                // 最大文字幅
                var maxWidth = this.getCharacterInfoArrayVerticalInLine(array, degrees, lineIndex, maxr, maxr, centerX, centerY);

                // 揃え調整
                if(this.layer.horizontalAlignment == 1)
                {
                    // 中央揃え
                    // 上揃え・下揃えの中間であることを念頭に
                    // 一番下の文字の高さ
                    var lastInfo = array[array.length - 1];
                    var lastCharacterHeight = lastInfo.height;
                    // この高さ -> 最小フォントサイズ * 4 で同じ文字を描いた時の高さ の割合
                    var minScaledFontSize = UnitHelper.convert(CircleTextLayerDrawer.MIN_FONT_SIZE * 4, "pt", "mm") * this.scale;
                    var isHankaku = StringHelper.isHankaku(lastInfo.character);
                    var minTextSize = this.calcTextSize(lastInfo.character, minScaledFontSize, lastInfo.textInfo.fontId, lastInfo.textInfo.bold, lastInfo.textInfo.italic, true);
                    var toMinScale = minTextSize.height / lastCharacterHeight;
                    // まず同じ行番号を削除
                    for(var i = array.length - 1; i >= 0; --i)
                    {
                        if(lineIndex == array[i].lineIndex) { array.splice(i, 1); }
                    }
                    var startr = maxr * (1 + toMinScale) / 2;
                    this.getCharacterInfoArrayVerticalInLine(array, degrees, lineIndex, startr, maxr, centerX, centerY);
                }
                else if(this.layer.horizontalAlignment == 2)
                {
                    // 下揃え
                    // 一番下の文字の高さ
                    var lastInfo = array[array.length - 1];
                    var lastCharacterHeight = lastInfo.height;
                    // この高さ -> 最小フォントサイズ * 4 で同じ文字を描いた時の高さ の割合
                    var minScaledFontSize = UnitHelper.convert(CircleTextLayerDrawer.MIN_FONT_SIZE * 4, "pt", "mm") * this.scale;
                    var isHankaku = StringHelper.isHankaku(lastInfo.character);
                    var minTextSize = this.calcTextSize(lastInfo.character, minScaledFontSize, lastInfo.textInfo.fontId, lastInfo.textInfo.bold, lastInfo.textInfo.italic, true);
                    var toMinScale = minTextSize.height / lastCharacterHeight;
                    // 初期半径をtoMinScale倍にして、この行を再設定する
                    // まず同じ行番号を削除
                    for(var i = array.length - 1; i >= 0; --i)
                    {
                        if(lineIndex == array[i].lineIndex) { array.splice(i, 1); }
                    }
                    this.getCharacterInfoArrayVerticalInLine(array, degrees, lineIndex, maxr * toMinScale, maxr, centerX, centerY);
                }

                // 行を送る
                // 最大文字幅が円周に占める割合で算出する
                degrees += 360 * (maxWidth * this.layer.lineSpacing / 100) / ( maxr * 2 * Math.PI );
            }
        }

        // 縦書き用文字変換
        if(UserAgentHelper.getBrowser() == "safari" && !this.isRendering && array.length > 0)
        {
            for(var i = 0; i < array.length; ++i)
            {
                if(!array[i].textInfo.isHorizontalInVertical)
                {
                    if(StringHelper.isHankaku(array[i].character))
                    {
                        // nothing
                    }
                    else
                    {
                        array[i].character = StringHelper.toVerticalString(array[i].character);
                    }
                }
            }
        }

        // 判定領域設定
        for(var i = 0; i < array.length; ++i)
        {
            var bounds = new Rectangle(array[i].x, array[i].y, array[i].width, array[i].height);
            array[i].boundsBefore = new Rectangle(bounds.x - bounds.width / 2, bounds.y, bounds.width, bounds.height / 2);
            array[i].boundsAfter = new Rectangle(bounds.x - bounds.width / 2, bounds.y + bounds.height / 2, bounds.width, bounds.height / 2);
        }

        return array;
    }

    private getCharacterInfoArrayVerticalInLine(array, degrees : number, lineIndex : number, startr : number, maxr : number, centerX : number, centerY : number, isInner : boolean = false)
    {
        // フォントマネージャー
        var fontManager : FontManager = this.$store.getters.fontManager;

        var r = startr;
        var maxWidth = 0;
        var rate = r / maxr;
        var characterCount = this.layer.getCharacterCount(lineIndex, this.isPlaceholderVisible);
        if(isInner)
        {
            // 内向き

            if(characterCount == 0)
            {
                // 空白行
                var info = this.layer.getCharacterInfo(lineIndex, 0, this.isPlaceholderVisible);
                if(info != null)
                {
                    var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                    var size = this.calcTextSize("8", scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, true);
                    maxWidth = Math.max(size.width, maxWidth);
                    var rad = degrees * Math.PI / 180;
                    var x = centerX + (r) * Math.cos(rad);
                    var y = centerY - (r) * Math.sin(rad);

                    array.push({
                        character : "",
                        lineIndex : lineIndex,
                        characterIndex : 0,
                        textInfo : info.textInfo,
                        x : x,
                        y : y,
                        width : size.width,
                        height : size.height,
                        fontSize : scaledFontSize,
                        letterWidth : info.textInfo.letterWidth,
                        rotate : 270 - degrees,
                        uuid : UuidHelper.getUuid(),
                        boundsBefore : new Rectangle(),
                        boundsAfter : new Rectangle()
                    });
                }
            }
            else
            {
                var tempArray = new Array();
                for(var characterIndex = characterCount; characterIndex >= 0; --characterIndex)
                {
                    var info = this.layer.getCharacterInfo(lineIndex, characterIndex, this.isPlaceholderVisible);
                    if(info != null)
                    {
                        var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                        var isHankaku = StringHelper.isHankaku(info.character);
                        var size = this.calcTextSize(info.character, scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, true);
                        maxWidth = Math.max(size.width, maxWidth);
                        // 半径
                        r -= size.height * info.textInfo.letterWidth / 100;
                        // 半径が0以下ならこの行は終了
                        if(r <= 0) { break; }

                        // 円周
                        var c = 2 * r * Math.PI;

                        var rad = degrees * Math.PI / 180;
                        var x = centerX + (r) * Math.cos(rad);
                        var y = centerY - (r) * Math.sin(rad);

                        tempArray.push({
                            character : info.character,
                            lineIndex : lineIndex,
                            characterIndex : characterIndex,
                            textInfo : info.textInfo,
                            x : x,
                            y : y,
                            width : size.width,
                            height : size.height,
                            fontSize : scaledFontSize,
                            letterWidth : info.textInfo.letterWidth,
                            rotate : 270 - degrees,
                            uuid : UuidHelper.getUuid(),
                            boundsBefore : new Rectangle(),
                            boundsAfter : new Rectangle()
                        });

                        // 文字間を送る
                        r -= UnitHelper.convert(info.textInfo.letterSpacing, "pt", "mm") * rate * this.scale;
                        // 縮小率更新
                        rate = r / maxr;
                    }
                }

                // characterIndex順になるように入れ直す
                for(var i = tempArray.length - 1; i >= 0; --i)
                {
                    array.push(tempArray[i]);
                }
            }
        }
        else
        {
            // 外向き

            if(characterCount == 0)
            {
                // 空白行
                var info = this.layer.getCharacterInfo(lineIndex, 0, this.isPlaceholderVisible);
                if(info != null)
                {
                    var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                    var size = this.calcTextSize("8", scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, true);
                    maxWidth = Math.max(size.width, maxWidth);
                    var rad = degrees * Math.PI / 180;
                    var x = centerX + (r + size.height * info.textInfo.letterWidth / 100) * Math.cos(rad);
                    var y = centerY - (r + size.height * info.textInfo.letterWidth / 100) * Math.sin(rad);

                    array.push({
                        character : "",
                        lineIndex : lineIndex,
                        characterIndex : 0,
                        textInfo : info.textInfo,
                        x : x,
                        y : y,
                        width : size.width,
                        height : size.height,
                        fontSize : scaledFontSize,
                        letterWidth : info.textInfo.letterWidth,
                        rotate : 270 - degrees,
                        uuid : UuidHelper.getUuid(),
                        boundsBefore : new Rectangle(),
                        boundsAfter : new Rectangle()
                    });
                }
            }
            else
            {
                for(var characterIndex = 0; characterIndex < characterCount; ++characterIndex)
                {
                    var info = this.layer.getCharacterInfo(lineIndex, characterIndex, this.isPlaceholderVisible);
                    if(info != null)
                    {
                        var scaledFontSize = UnitHelper.convert(info.textInfo.fontSize, "pt", "mm") * rate * this.scale;
                        var isHankaku = StringHelper.isHankaku(info.character);
                        var size = this.calcTextSize(info.character, scaledFontSize, info.textInfo.fontId, info.textInfo.bold, info.textInfo.italic, true);
                        maxWidth = Math.max(size.width, maxWidth);
                        // 半径
                        r -= size.height * info.textInfo.letterWidth / 100;
                        // 半径が0以下ならこの行は終了
                        if(r <= 0) { break; }

                        // 円周
                        var c = 2 * r * Math.PI;

                        var rad = degrees * Math.PI / 180;
                        var x = centerX + (r + size.height * info.textInfo.letterWidth / 100) * Math.cos(rad);
                        var y = centerY - (r + size.height * info.textInfo.letterWidth / 100) * Math.sin(rad);

                        array.push({
                            character : info.character,
                            lineIndex : lineIndex,
                            characterIndex : characterIndex,
                            textInfo : info.textInfo,
                            x : x,
                            y : y,
                            width : size.width,
                            height : size.height,
                            fontSize : scaledFontSize,
                            letterWidth : info.textInfo.letterWidth,
                            rotate : 90 - degrees,
                            uuid : UuidHelper.getUuid(),
                            boundsBefore : new Rectangle(),
                            boundsAfter : new Rectangle()
                        });

                        // 文字間を送る
                        r -= UnitHelper.convert(info.textInfo.letterSpacing, "pt", "mm") * rate * this.scale;
                        // 縮小率更新
                        rate = r / maxr;
                    }
                }
            }
        }

        // 最大幅を返す
        return maxWidth;
    }

    // 下線配列
    private get underlineArray() : Array<{
        path : string,                   // パス
        strokeWidth : number,            // 太さ
        color : string,                  // 色(hex)
        uuid : string                    // UUID
    }>
    {
        var array = new Array();

        // 円弧の中心座標
        var centerX = this.layer.x * this.scale + this.offsetX + this.layer.width * this.scale / 2;
        var centerY = this.layer.y * this.scale + this.offsetY + this.layer.height * this.scale / 2;

        var tempArray = new Array();
        for(var i = 0; i < this.characterInfoArray.length; ++i)
        {
            var info = this.characterInfoArray[i];
            // 文字情報を追加
            tempArray.push(info);
            var isLastInLine = i == this.characterInfoArray.length - 1 || this.characterInfoArray[i + 1].lineIndex != info.lineIndex;
            if(isLastInLine)
            {
                // この文字が行終了
                if(this.layer.textOrientation == 1)
                {
                    // 縦書き *傍線を右に引く

                    // レイヤー全体としてアンダーラインがない場合は何も描かない
                    if(!this.layer.baseTextInfo.underline) { return array; }

                    // 最大となるテキストの幅を求める
                    var maxWidth = 0;
                    // 傍線の幅
                    var underlineW = UnitHelper.convert(this.layer.baseTextInfo.fontSize, "pt", "mm") * this.scale * CircleTextLayerDrawer.UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT;

                    if(tempArray.length == 1 && tempArray[0].character != "")
                    {
                        // 文字が１つ
                        var tempInfo = tempArray[0];

                        var degrees = 90 - tempInfo.rotate;
                        var rad = degrees * Math.PI / 180;

                        let startX = tempInfo.x + tempInfo.width * Math.sin(rad) / 2;
                        let startY = tempInfo.y + tempInfo.width * Math.cos(rad) / 2;

                        let endX = startX - (tempInfo.height * tempInfo.letterWidth / 100) * Math.cos(rad);
                        let endY = startY + (tempInfo.height * tempInfo.letterWidth / 100) * Math.sin(rad);

                        var svgPath;
                        if(this.layer.direction == 1)
                        {
                            svgPath = encodeSVGPath(
                                [
                                    { type: SVGPathData.MOVE_TO, relative: false, x: startX, y: startY },
                                    { type: SVGPathData.LINE_TO, relative: false, x: endX, y: endY }
                                ]
                            );
                        }
                        else
                        {
                            svgPath = encodeSVGPath(
                                [
                                    { type: SVGPathData.MOVE_TO, relative: false, x: startX, y: startY },
                                    { type: SVGPathData.LINE_TO, relative: false, x: endX, y: endY }
                                ]
                            );
                        }
                        let underlineColor : string = tempArray[0].textInfo.textColor.hex;
                        array.push({ path : svgPath, strokeWidth : underlineW, color : underlineColor, uuid : UuidHelper.getUuid() });
                    }
                    else if(tempArray.length > 1)
                    {
                        // 文字が２つ以上
                        var tempInfo = tempArray[0];
                        var lastInfo = tempArray[tempArray.length - 1];

                        var degrees = 90 - tempInfo.rotate;
                        var rad = degrees * Math.PI / 180;

                        let startX = tempInfo.x + tempInfo.width * Math.sin(rad) / 2;
                        let startY = tempInfo.y + tempInfo.width * Math.cos(rad) / 2;

                        let endX = lastInfo.x + lastInfo.width * Math.sin(rad) / 2 - (lastInfo.height * lastInfo.letterWidth / 100) * Math.cos(rad);
                        let endY = lastInfo.y + lastInfo.width * Math.cos(rad) / 2 + (lastInfo.height * lastInfo.letterWidth / 100) * Math.sin(rad);

                        var svgPath;
                        if(this.layer.direction == 1)
                        {
                            svgPath = encodeSVGPath(
                                [
                                    { type: SVGPathData.MOVE_TO, relative: false, x: startX, y: startY },
                                    { type: SVGPathData.LINE_TO, relative: false, x: endX, y: endY }
                                ]
                            );
                        }
                        else
                        {
                            svgPath = encodeSVGPath(
                                [
                                    { type: SVGPathData.MOVE_TO, relative: false, x: startX, y: startY },
                                    { type: SVGPathData.LINE_TO, relative: false, x: endX, y: endY }
                                ]
                            );
                        }
                        let underlineColor : string = tempArray[0].textInfo.textColor.hex;
                        array.push({ path : svgPath, strokeWidth : underlineW, color : underlineColor, uuid : UuidHelper.getUuid() });
                    }
                }
                else
                {
                    // 横書き

                    // 空白行は飛ばす
                    if(tempArray.length == 1 && tempArray[0].character == "")
                    {
                        tempArray = new Array();
                        continue;
                    }

                    // 最大となるテキストの高さを求める
                    var maxHeight = 0;
                    for(var t = 0; t < tempArray.length; ++t)
                    {
                        var tempInfo = tempArray[t];
                        maxHeight = Math.max(tempInfo.height, maxHeight);
                    }
                    // 下線の高さ
                    var underlineHeight = maxHeight * CircleTextLayerDrawer.UNDERLINE_HEIGHT_FROM_CHARACTER_HEIGHT;
                    // 下線の情報を追加していく
                    for(var t = 0; t < tempArray.length; ++t)
                    {
                        var tempInfo = tempArray[t];
                        if(tempInfo.character != "" && tempInfo.textInfo.underline)
                        {
                            // 次の文字にアンダーラインがあるか？
                            var isNextUnderline = false;
                            if(t < tempArray.length - 1)
                            {
                                var nextTemp = tempArray[t + 1];
                                isNextUnderline = nextTemp.textInfo.underline;
                            }

                            var rad = tempInfo.rotate * Math.PI / 180;

                            var startX = tempInfo.x;
                            var startY = tempInfo.y;
                            var endX = isNextUnderline ? tempArray[t + 1].x : tempInfo.x + (tempInfo.width * tempInfo.letterWidth / 100) * Math.cos(rad);
                            var endY = isNextUnderline ? tempArray[t + 1].y : tempInfo.y + (tempInfo.width * tempInfo.letterWidth / 100) * Math.sin(rad);
                            // 半径
                            var r = Math.sqrt((startX - centerX) * (startX - centerX) + (startY - centerY) * (startY - centerY));
                            // 下線を示すパス
                            var svgPath;
                            if(this.layer.direction == 1)
                            {
                                svgPath = encodeSVGPath(
                                    [
                                        { type: SVGPathData.MOVE_TO, relative: false, x: startX, y: startY },
                                        { type: SVGPathData.ARC, relative: false, x: endX, y: endY, rX: r, rY: r, xRot: 0, lArcFlag: 0, sweepFlag: 0 }
                                    ]
                                );
                            }
                            else
                            {
                                svgPath = encodeSVGPath(
                                    [
                                        { type: SVGPathData.MOVE_TO, relative: false, x: startX, y: startY },
                                        { type: SVGPathData.ARC, relative: false, x: endX, y: endY, rX: r, rY: r, xRot: 0, lArcFlag: 0, sweepFlag: 1 }
                                    ]
                                );
                            }
                            let underlineColor = tempInfo.textInfo.textColor.hex;
                            array.push({ path : svgPath, strokeWidth : underlineHeight, color : underlineColor, uuid : UuidHelper.getUuid() });
                        }
                    }
                }

                tempArray = new Array();
            }
        }

        return array;
    }

    // positionを元にcharacterInfoを得る
    // characterInfo
    // isFirstInLine : [行の先頭かどうか]
    private getCharacterInfoFromPosition(position)
    {
        var indexPair = this.layer.getLineAndCharacterIndexFromPosition(position);
        var array = this.characterInfoArray;
        for(var info of array)
        {
            if(info.lineIndex == indexPair.lineIndex && info.characterIndex == indexPair.characterIndex)
            {
                return { characterInfo : info, isFirstInLine : indexPair.isFirstInLine };
            }
        }
        return null;
    }

    // キャレットを表示するか
    private get charetVisible()
    {
        // レンダリング中は表示しない
        if(this.isRendering) { return false; }
        // エディット対象でなければ表示しない
        if(!this.isInEditor) { return false; }
        return this.layer.inEdit && this.layer.startPosition == this.layer.endPosition;
    }

    // キャレット位置
    // x1, y1, x2, y2
    private getCharetPos()
    {
        var info = this.getCharacterInfoFromPosition(this.layer.startPosition);
        if(info == null) { return { x1 : 0, y1 : 0, x2 : 0, y2 : 0}; }

        var x1 = 0;
        var y1 = 0;
        var x2 = 0;
        var y2 = 0;
        if(this.layer.textOrientation == 1)
        {
            // 縦書き
            var rad = (90 - info.characterInfo.rotate) * Math.PI / 180;
            if(info.isFirstInLine)
            {
                x2 = info.characterInfo.x + info.characterInfo.width * Math.sin(rad) / 2;
                y2 = info.characterInfo.y + info.characterInfo.width * Math.cos(rad) / 2;
                x1 = x2 - info.characterInfo.width * Math.sin(rad);
                y1 = y2 - info.characterInfo.width * Math.cos(rad);
            }
            else
            {
                x2 = info.characterInfo.x + info.characterInfo.width * Math.sin(rad) / 2 - info.characterInfo.height * info.characterInfo.letterWidth / 100 * Math.cos(rad);
                y2 = info.characterInfo.y + info.characterInfo.width * Math.cos(rad) / 2 + info.characterInfo.height * info.characterInfo.letterWidth / 100 * Math.sin(rad);
                x1 = x2 - info.characterInfo.width * Math.sin(rad);
                y1 = y2 - info.characterInfo.width * Math.cos(rad);
            }
        }
        else
        {
            // 横書き
            var rad = info.characterInfo.rotate * Math.PI / 180;
            if(info.isFirstInLine)
            {
                x2 = info.characterInfo.x;
                y2 = info.characterInfo.y;
                x1 = x2 + info.characterInfo.height * Math.sin(rad);
                y1 = y2 - info.characterInfo.height * Math.cos(rad);
            }
            else
            {
                x2 = info.characterInfo.x + info.characterInfo.width * info.characterInfo.letterWidth / 100 * Math.cos(rad);
                y2 = info.characterInfo.y + info.characterInfo.width * info.characterInfo.letterWidth / 100 * Math.sin(rad);
                x1 = x2 + info.characterInfo.height * Math.sin(rad);
                y1 = y2 - info.characterInfo.height * Math.cos(rad);
            }
        }

        return { x1 : x1, y1 : y1, x2 : x2, y2 : y2 };
    }

    // 選択を表示するか
    private get selectionVisible()
    {
        // レンダリング中は表示しない
        if(this.isRendering) { return false; }
        // エディット対象でなければ表示しない
        if(!this.isInEditor) { return false; }
        return this.layer.inEdit && this.layer.startPosition != this.layer.endPosition;
    }

    // 選択領域
    // path : パス
    private get selectionRectArray()
    {
        var start = Math.min(this.layer.startPosition, this.layer.endPosition);
        var end = Math.max(this.layer.startPosition, this.layer.endPosition);
        var pathArray = new Array();
        for(var i = start + 1; i <= end; ++i)
        {
            var info = this.getCharacterInfoFromPosition(i);
            if(info != null)
            {
                if(this.layer.textOrientation == 1 && !info.characterInfo.textInfo.isHorizontalInVertical)
                {
                    // 縦書き
                    var rad = (90 - info.characterInfo.rotate) * Math.PI / 180;
                    var x0 = info.characterInfo.x - info.characterInfo.width * Math.sin(rad) / 2;
                    var y0 = info.characterInfo.y - info.characterInfo.width * Math.cos(rad) / 2;
                    var x1 = x0 - info.characterInfo.height * info.characterInfo.letterWidth / 100 * Math.cos(rad);
                    var y1 = y0 + info.characterInfo.height * info.characterInfo.letterWidth / 100 * Math.sin(rad);
                    var x2 = x1 + info.characterInfo.width * Math.sin(rad);
                    var y2 = y1 + info.characterInfo.width * Math.cos(rad);
                    var x3 = x2 + info.characterInfo.height * info.characterInfo.letterWidth / 100 * Math.cos(rad);
                    var y3 = y2 - info.characterInfo.height * info.characterInfo.letterWidth / 100 * Math.sin(rad);
                    var path = encodeSVGPath(
                        [
                            { type: SVGPathData.MOVE_TO, relative: false, x: x0, y: y0 },
                            { type: SVGPathData.LINE_TO, relative: false, x: x1, y: y1 },
                            { type: SVGPathData.LINE_TO, relative: false, x: x2, y: y2 },
                            { type: SVGPathData.LINE_TO, relative: false, x: x3, y: y3 },
                            { type: SVGPathData.CLOSE_PATH }
                        ]
                    );
                    pathArray.push({ path : path });
                }
                else
                {
                    // 横書き
                    var rad = -info.characterInfo.rotate * Math.PI / 180;
                    var x0 = info.characterInfo.x - info.characterInfo.height * Math.sin(rad);
                    var y0 = info.characterInfo.y - info.characterInfo.height * Math.cos(rad);
                    var x1 = x0 + info.characterInfo.height * Math.sin(rad);
                    var y1 = y0 + info.characterInfo.height * Math.cos(rad);
                    var x2 = x1 + info.characterInfo.width * info.characterInfo.letterWidth / 100 * Math.cos(rad);
                    var y2 = y1 - info.characterInfo.width * info.characterInfo.letterWidth / 100 * Math.sin(rad);
                    var x3 = x2 - info.characterInfo.height * Math.sin(rad);
                    var y3 = y2 - info.characterInfo.height * Math.cos(rad);
                    var path = encodeSVGPath(
                        [
                            { type: SVGPathData.MOVE_TO, relative: false, x: x0, y: y0 },
                            { type: SVGPathData.LINE_TO, relative: false, x: x1, y: y1 },
                            { type: SVGPathData.LINE_TO, relative: false, x: x2, y: y2 },
                            { type: SVGPathData.LINE_TO, relative: false, x: x3, y: y3 },
                            { type: SVGPathData.CLOSE_PATH }
                        ]
                    );
                    pathArray.push({ path : path });
                }
            }
        }

        return pathArray;
    }

    private getCharacterStyle(characterInfo)
    {
        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        var style = {
            "font-family" : this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo, isHankaku),
            "fill" : characterInfo.textInfo.textColor.hex
        };
        if(isVertical)
        {
            // 縦書き *縦中横の場合は除く
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }
        return style;
    }

    private isVisibleOutline(characterInfo)
    {
        return characterInfo.textInfo.isOutline;
    }

    private getOutlineStyle(characterInfo)
    {
        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        var outlineThickness = characterInfo.fontSize * characterInfo.textInfo.outlineThickness / 750;
        var style = {
            "font-family" : this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo, isHankaku),
            "fill" : "none",
            "stroke" : characterInfo.textInfo.outlineColor.hex,
            "stroke-width" : this.alternativeOutlineThickness(characterInfo) + outlineThickness,
            "stroke-linejoin" : "round",
            "opacity" : MathHelper.clamp(characterInfo.textInfo.outlineIntensity / 100, 0, 1)
        };
        if(isVertical)
        {
            // 縦書き *縦中横の場合は除く
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }
        return style;
    }

    private isVisibleAlternativeOutline(characterInfo) {
        return characterInfo.textInfo.bold && FontManager.UseAlternativeOutlineToBold(characterInfo.textInfo.fontId);
    }

    private alternativeOutlineThickness(characterInfo) {
        return this.isVisibleAlternativeOutline(characterInfo) ? characterInfo.fontSize * 24 / 750 : 0;
    }

    private alternativeOutlineStyle(characterInfo) {
        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        var style = {
            "font-family" : this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo, isHankaku),
            "fill" : "none",
            "stroke" : characterInfo.textInfo.textColor.hex,
            "stroke-width" : this.alternativeOutlineThickness(characterInfo),
            "stroke-linejoin" : "round"
        };
        if(isVertical)
        {
            // 縦書き *縦中横の場合は除く
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }
        return style;
    }

    private isShadow(characterInfo)
    {
        return characterInfo.textInfo.isShadow;
    }

    private shadowBlurFilterId(characterInfo)
    {
        return "shadowBlurFilterId_" + characterInfo.uuid;
    }

    private blurFilterUrl(characterInfo)
    {
        return "url(#" + this.shadowBlurFilterId(characterInfo) + ")";
    }

    private getTextShadowDiviation(characterInfo)
    {
        // 出力時は影を弱くする
        var path = this.$router.currentRoute.path;
        var fix = path == "/PrintSetting" && this.isRendering ? 0.2 : 1;
        return characterInfo.textInfo.shadowBlur / 10 * fix;
    }

    private getShadowPosition(characterInfo)
    {
        // 影
        var distance = characterInfo.fontSize * 2 * characterInfo.textInfo.shadowDistance / 100;
        var radian = characterInfo.textInfo.shadowRotate * Math.PI / 180;
        var xDistance = distance * Math.cos(radian);
        var yDistance = distance * Math.sin(radian);
        return { x : characterInfo.x + xDistance, y : characterInfo.y + yDistance }
    }

    private getShadowStyle(characterInfo)
    {
        var shadowColorR = characterInfo.textInfo.shadowColor.r;
        var shadowColorG = characterInfo.textInfo.shadowColor.g;
        var shadowColorB = characterInfo.textInfo.shadowColor.b;
        var shadowColorA = MathHelper.clamp(characterInfo.textInfo.shadowIntensity / 100, 0, 1);
        var shadowColorRgba = "rgba(" + shadowColorR + "," + shadowColorG + "," + shadowColorB + "," + shadowColorA + ")";

        var isHankaku = StringHelper.isHankaku(characterInfo.character);
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        var style = {
            "font-family" : this.getFontFamily(characterInfo.textInfo, isHankaku, isVertical),
            "font-size" : characterInfo.fontSize,
            "font-weight" : this.getFontWeight(characterInfo.textInfo),
            "font-style" : this.getFontStyle(characterInfo.textInfo, isHankaku),
            "fill" : shadowColorRgba
        };
        if(isVertical)
        {
            // 縦書き *縦中横の場合は除く
            style["-webkit-writing-mode"] = "vertical-rl";
            style["-ms-writing-mode"] = "tb-rl";
            style["writing-mode"] = "vertical-rl";
        }
        return style;
    }

    private getWritingMode(characterInfo)
    {
        var isVertical = this.layer.textOrientation == 1 && !characterInfo.textInfo.isHorizontalInVertical;
        return isVertical ? "tb" : "lr";
    }

    private getFontFamily(textInfo, isHankaku = false, isVertical = false) : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        return fontManager.getFontFamilyName(textInfo.fontId, isHankaku, this.isRendering && !this.isRenderingOnClient, isVertical, this.isRenderingOnClient);
    }

    private getFontWeight(textInfo) : string
    {
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(textInfo.fontId);
        // 太字の代わりに縁取りを使用する場合はboldをfalseとして扱う
        let bold = textInfo.bold;
        if(FontManager.UseAlternativeOutlineToBold(textInfo.fontId)) bold = false;
        // ウェイトがない場合はボールド設定を返す
        if(font.weight == null) { return bold ? "bold" : "normal"; }
        // レンダリング中はウェイト数値が無効なので、700以上かボールド設定ならボールド、それ以外ならnormalを返す
        if(this.isRendering && !this.isRenderingOnClient) { return (font.weight >= 700 || bold) ? "bold" : "normal"; }
        // ボールド設定がない場合はウェイトを返す
        if(!bold) { return font.weight.toString(); }
        // 700 = bold なので、weightがこの値より大きいならこの値を使い、それ以下のときはboldを指定する。
        return font.weight > 700 ? font.weight.toString() : "bold";
    }

    private getFontStyle(textInfo, isHankaku = false) : string
    {
        // var fontManager : FontManager = this.$store.getters.fontManager;
        // return textInfo.italic && fontManager.canItalic(textInfo.fontId, isHankaku) ? "italic" : "normal";
        return textInfo.italic ? "italic" : "normal";
    }

    private get transform() : string
    {
        var transform = "";

        // オフセット
        var offsetX = this.offsetX + this.layer.x * this.scale;
        var offsetY = this.offsetY + this.layer.y * this.scale;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        // オフセット
        transform += "translate(" + -offsetX + " " + -offsetY + ")";

        return transform;
    }

    private getCharacterTransform(characterInfo) : string
    {
        var characterTransform = "";

        // レイヤーの変形
        characterTransform += this.transform + ",";

        // 文字の変形
        characterTransform += "translate(" + characterInfo.x + " " + characterInfo.y + "),";

        // 文字の回転
        characterTransform += "rotate(" + characterInfo.rotate + "),";

        if(this.layer.textOrientation == 1)
        {
            // 縦書き
            characterTransform += "scale(" + "1 " + (characterInfo.letterWidth / 100) + "),";
            // if(this.isRendering && !characterInfo.textInfo.isHorizontalInVertical)
            // {
            //     // レンダリング位置調整
            //     //characterTransform += "translate(" + (-characterInfo.width / 10 * 3) + " " + 0 + "),";

            //     if(StringHelper.isHankaku(characterInfo.character))
            //     {
            //         // 半角文字は90度回転
            //         //characterTransform += "rotate(" + 90 + "),";
            //     }
            //     else
            //     {
            //        // characterTransform += "translate(" + 0 + " " + characterInfo.height / 10 * 9 + "),";
            //     }
            // }

            // Safariで縦書きのみ位置補正
            if(!this.isRendering && UserAgentHelper.getBrowser() == "safari")
            {
                if(!StringHelper.isHankaku(characterInfo.character))
                {
                    characterTransform += "translate(" + 0 + " " + -characterInfo.height / 4 + "),";
                }
            }

            // IEで位置補正
            if(!this.isRendering && UserAgentHelper.getBrowser() == "ie")
            {
                if(!StringHelper.isHankaku(characterInfo.character))
                {
                    characterTransform += "translate(" + -characterInfo.width / 4 + " " + 0 + "),";
                }
            }
        }
        else
        {
            // 横書き
            characterTransform += "scale(" + (characterInfo.letterWidth / 100) + " 1),";
        }

        characterTransform += "translate(" + -characterInfo.x + " " + -characterInfo.y + ")";

        return characterTransform;
    }

    // テキスト領域判定
    private onTextBounds(info, isAfter : boolean)
    {
        // 選択中のテキスト位置を保持
        this.layer.selectedLineIndex = info.lineIndex;
        this.layer.selectedCharacterIndex = info.characterIndex;
        this.layer.isAfterSelected = isAfter;
    }

    private calcTextSize(str : string, fontSize : number, fontId : string = "", isBold : boolean = false, isItalic : boolean = false, isVertical : boolean = false)
    {
        var isHankaku = StringHelper.isHankaku(str);

        // fontSize -> pt
        var fontSizePt = UnitHelper.convert(fontSize / this.scale, "mm", "pt");
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(fontId);

        // fontFamily
        var fontFamily = fontManager.getFontFamilyName(fontId, isHankaku, false, isVertical);

        // weight
        var weight = "normal";
        if(font.weight == null)
        {
            // ウェイトがない場合はボールド設定を返す
            weight = isBold ? "bold" : "normal";
        }
        else
        {
            // ウェイトがある場合
            if(isBold)
            {
                weight = font.weight > 700 ? font.weight.toString() : "bold";
            }
            else
            {
                weight = font.weight.toString();
            }
        }

        // style
        var style = isItalic ? "italic" : "normal";

        var ptSize = StringHelper.calcTextSizeOnSVGPt(str, fontSizePt, fontFamily, weight, style, isVertical);

        var width = UnitHelper.convert(ptSize.width, "pt", "mm") * this.scale;
        var height = UnitHelper.convert(ptSize.height, "pt", "mm") * this.scale;

        return { width : width, height : height };
    }
}
